export default "__VITE_ASSET__0VBhzWc8__"